import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { PageHeader } from 'antd';
import history from '@utils/history';
import { PropertySelectors } from '@redux/PropertyRedux';

import { PropertyEdit, PropertySider } from '@containers/properties';

import './CreateProperty.less';

function EditPropertyPage(props) {
  const { basicInfo, propertyId } = props;
  const { name } = basicInfo;

  return (
    <div className="properties main-page">
      <PageHeader
        title={`Edit: ${name}`}
        style={{
          border: '1px solid rgb(235, 237, 240)'
        }}
        onBack={() => history.goBack()}
      />

      <div className="property main-content">
        <div className="property-sider">
          <PropertySider propertyId={propertyId} />
        </div>

        <div className="property-content">
          <PropertyEdit propertyId={propertyId} />
        </div>
      </div>
    </div>
  );
}

EditPropertyPage.propTypes = {
  basicInfo: PropTypes.object,
  propertyId: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
};

const mapStateToProps = state => ({
  propertyId: PropertySelectors.selectPropertyId(state),
  basicInfo: PropertySelectors.selectBasicInfo(state)
});
export default connect(mapStateToProps)(EditPropertyPage);
